import React, { useEffect, useState } from "react";
import Footer from "components/home/Footer";
import NavBar from "components/home/Navbar";
import QuickInquiryModal from "components/home/QuickInquiryModal";
import { footerSections } from "components/home/homeData";

export default function TermsOfService() {

    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
    
        html.style.overflow = "auto";
        body.style.overflow = "auto";
    
        html.style.overscrollBehavior = "auto";
        body.style.overscrollBehavior = "auto";
    
        return () => {
          html.style.overflow = "";
          body.style.overflow = "";
    
          html.style.overscrollBehavior = "";
          body.style.overscrollBehavior = "";
        };
      }, []);

    const [isQuickInquiryOpen, setIsQuickInquiryOpen] = useState(false);
    const [quickInquiryPosition, setQuickInquiryPosition] = useState<{ top: number; left: number } | null>(null);

    const openQuickInquiry = (event: React.MouseEvent<HTMLButtonElement>) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const panelWidth = 360;
        const panelHeight = 430;
        const viewportPadding = 12;

        let left = rect.right + 10;
        if (left + panelWidth > window.innerWidth - viewportPadding) {
            left = rect.left - panelWidth - 10;
        }
        left = Math.max(viewportPadding, Math.min(left, window.innerWidth - panelWidth - viewportPadding));

        let top = rect.top - panelHeight - 10;
        top = Math.max(viewportPadding, Math.min(top, window.innerHeight - panelHeight - viewportPadding));

        setQuickInquiryPosition({ top, left });
        setIsQuickInquiryOpen(true);
    };

    return (
        <div className="min-h-screen bg-white pt-10 font-sans">
            <NavBar signInHref="/login" signUpHref="/registration" />

            <section className="bg-gradient-to-br from-blue-50 via-blue-100 to-indigo-100 py-10">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="bg-white rounded-2xl border border-[#dbe4f2] shadow-[0_16px_35px_rgba(17,46,96,0.08)] p-6 sm:p-8">
                        <h1 className="text-4xl sm:text-5xl font-bold text-[#0f1b35] mb-2">Terms of Service</h1>
                        <p className="text-base text-[#5a6b89] mb-8">Effective date: May 7, 2026</p>

                        <div className="space-y-7 text-[#334b73]">
                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">1. Acceptance of Terms</h2>
                                <p className="text-base leading-8">
                                    By accessing or using Liriworks services, you agree to be bound by these Terms of Service and all applicable laws.
                                    If you do not agree, you must discontinue use of the services.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">2. Services</h2>
                                <p className="text-base leading-8">
                                    Liriworks provides workforce and operations management tools, including associated web features,
                                    dashboards, and integrations. We may update, suspend, or discontinue parts of the service at any time.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">3. User Accounts and Responsibilities</h2>
                                <ul className="list-disc pl-5 text-base leading-8 space-y-1">
                                    <li>You are responsible for maintaining account credentials and access controls.</li>
                                    <li>You agree to provide accurate information and keep account data updated.</li>
                                    <li>You are responsible for activities performed under your account.</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">4. Acceptable Use</h2>
                                <ul className="list-disc pl-5 text-base leading-8 space-y-1">
                                    <li>You may not use the service for unlawful, abusive, or fraudulent activities.</li>
                                    <li>You may not attempt unauthorized access, reverse engineering, or service disruption.</li>
                                    <li>You must comply with all applicable laws and third-party rights.</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">5. Intellectual Property</h2>
                                <p className="text-base leading-8">
                                    All platform content, trademarks, branding, and software are the property of Liriworks or its licensors.
                                    No ownership rights are transferred by using the service.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">6. Fees and Billing</h2>
                                <p className="text-base leading-8">
                                    Paid services, where applicable, are billed according to the agreed plan terms.
                                    You are responsible for payment obligations, taxes, and charges as defined in your subscription.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">7. Disclaimers and Limitation of Liability</h2>
                                <p className="text-base leading-8">
                                    Services are provided on an "as is" and "as available" basis, except as required by law.
                                    To the maximum extent permitted by law, Liriworks shall not be liable for indirect, incidental,
                                    consequential, or special damages.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">8. Termination</h2>
                                <p className="text-base leading-8">
                                    We may suspend or terminate access for violations of these terms, legal requirements,
                                    or security concerns. You may discontinue use at any time.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">9. Changes to Terms</h2>
                                <p className="text-base leading-8">
                                    We may revise these terms periodically. Continued use of the service after updates indicates acceptance
                                    of the revised terms.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-2xl font-semibold text-[#0f1b35] mb-2">10. Contact Information</h2>
                                <p className="text-base leading-8">
                                    For questions regarding these Terms of Service, contact us at:
                                    <br />
                                    1660, 18th Cross Rd, MC Layout, Vijayanagar, Bengaluru
                                    <br />
                                    <a className="text-blue-500 underline" href="mailto:support.india@lirisoft.com">support.india@lirisoft.com</a>
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
            </section>

            <Footer sections={footerSections} onQuickInquiryClick={openQuickInquiry} />
            <QuickInquiryModal
                isOpen={isQuickInquiryOpen}
                position={quickInquiryPosition}
                onClose={() => setIsQuickInquiryOpen(false)}
            />
        </div>
    );
}
